/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface FormerCompanyField
 */
export interface FormerCompanyField extends UpdatedField {
    /**
     * 
     * @type {string}
     * @memberof FormerCompanyField
     */
    value: string;
}

/**
 * Check if a given object implements the FormerCompanyField interface.
 */
export function instanceOfFormerCompanyField(value: object): value is FormerCompanyField {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function FormerCompanyFieldFromJSON(json: any): FormerCompanyField {
    return FormerCompanyFieldFromJSONTyped(json, false);
}

export function FormerCompanyFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormerCompanyField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'value': json['value'],
    };
}

export function FormerCompanyFieldToJSON(value?: FormerCompanyField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'value': value['value'],
    };
}

